"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
exports.default = new Network_1.default('mainnet', [
    new Token_1.default('ether', 'ETH', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} ETH', 'icon/eth.svg'),
    new Token_1.default('usdt', 'USDT', 'bifi', 1, '0xdac17f958d2ee523a2206206994597c13d831ec7', '', false, true, false, [], '{} USDT', 'icon/usdt.svg'),
    new Token_1.default('dai', 'DAI', 'bifi', 2, '0x6b175474e89094c44da98b954eedeac495271d0f', '', false, true, false, [], '{} DAI', 'icon/dai.svg'),
    new Token_1.default('link', 'LINK', 'bifi', 3, '0x514910771af9ca656af840dff83e8264ecf986ca', '', false, true, false, [], '{} LINK', 'icon/link.svg'),
    new Token_1.default('usdc', 'USDC', 'bifi', 4, '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', '', false, true, false, [], '{} USDC', 'icon/usdc.svg'),
    new Token_1.default('wbtc', 'WBTC', 'bifi', 5, '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599', '', false, true, false, [], '{} WBTC', 'icon/wbtc.svg'),
    new Token_1.default('btc', 'BTC', 'bifi', 6, '0x4ca7a5Fb41660A9c5c31683B832A17f7f7457344', '', false, true, false, [], '{} BTC', 'icon/btc.svg'),
    new Token_1.default('bnb', 'BNB', 'bifi', -1, '0xb8c77482e45f1f44de1745f52c74426c631bdd52', '', true, true, true, [], '{} BNB', 'icon/bnb.svg'),
    new Token_1.default('dot', 'DOT', 'bifi', -1, '', '', true, true, true, [], '{} DOT', 'icon/dot.svg'),
    new Token_1.default('kaia', 'KAIA', 'bifi', -1, '', '', true, true, true, [], '{} KAIA', 'icon/kaia.svg'),
    new Token_1.default('uniswap.bfceth', 'UNI-V2', 'pool.uniswap.bfceth', -1, '0x01688e1a356c38a8ed7c565bf6c6bfd59543a560', '', false, true, false, [
        'bfc',
        'ether'
    ], '{} UNI-V2', 'icon/bfceth.svg'),
    new Token_1.default('uniswap.bifieth', 'UNI-V2', 'pool.uniswap.bifieth', -1, '0x1ec9b867b701c1e5ce9a6567ecc4b71838497c27', '', false, true, false, [
        'bifi',
        'ether'
    ], '{} UNI-V2', 'icon/bifieth.svg'),
    new Token_1.default('sushiswap.bfceth', 'SLP', 'pool.sushiswap.bfceth', -1, '0x281df7fc89294c84afa2a21ffee8f6807f9c9226', '', false, true, false, [
        'bfc',
        'ether'
    ], '{} SLP', 'icon/bfceth.svg'),
    new Token_1.default('sushiswap.bifieth', 'SLP', 'pool.sushiswap.bifieth', -1, '0x0bec54c89a7d9f15c4e7faa8d47adedf374462ed', '', false, true, false, [
        'bifi',
        'ether'
    ], '{} SLP', 'icon/bifieth.svg'),
    new Token_1.default('bfc', 'BFC', 'stake.bfc', -1, '0x0c7d5ae016f806603cb1782bea29ac69471cab9c', '', false, true, false, [], '{} BFC', 'icon/bfc.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0x2791bfd60d232150bff86b39b7146c0eaaa2ba81', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'ether'),
    new Handler_1.default(1, 'usdt'),
    new Handler_1.default(2, 'dai'),
    new Handler_1.default(3, 'link'),
    new Handler_1.default(4, 'usdc'),
    new Handler_1.default(5, 'wbtc'),
    new Handler_1.default(6, 'btc')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('bifi.btcUserInfo', 'getETHUserInfo(address)', ['user.address'], ['address[]']),
    new Method_1.default('bifi.refundAddr', 'getRefundAddr(address)', ['user.address'], [
        'address',
        'uint32'
    ]),
    new Method_1.default('bifi.btcInflow', 'get_inflowPending(address)', ['user.address'], ['uint256']),
    new Method_1.default('bifi.btcOutflow', 'get_outflowInfo(address)', ['user.address'], ['(bool,uint64,uint128)']),
    new Method_1.default('bifi.btcChallenge', 'challengeCTX()', [], ['(bool,uint64,uint64,bytes32)']),
    new Method_1.default('srd.market', 'marketInformation(uint256,uint256)', [
        'blockNumber.from',
        'blockNumber.to'
    ], ['(uint256,uint256,uint256,uint256)']),
    new Method_1.default('srd.user', 'userInformation(address,uint256,uint256)', [
        'user.address',
        'blockNumber.from',
        'blockNumber.to'
    ], ['(uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('bifi.btcSubmittedUnit', 'get_heightByUnitID(bytes32)', ['unitID'], ['uint256']),
    new Method_1.default('bifi.btcConfirmGuarantee', 'Confirm_Guarantee()', [], ['uint256']),
    new Method_1.default('bifi.btcCurrentHeight', 'latestHeight()', [], ['uint256']),
    new Method_1.default('bifi.btcInflowFee', 'getInflowFeeParams()', [], ['uint256']),
    new Method_1.default('bifi.btcOutflowFee', 'getOutflowFeeParams()', [], ['uint256', 'uint256']),
    new Method_1.default('bifi.btcCalcInflowFee', 'calcInflowFee(uint256)', ['amount'], ['uint64', 'uint64']),
    new Method_1.default('bifi.btcCalcOutflowFee', 'calcOutflowFee(uint256)', ['amount'], ['uint64', 'uint256']),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256,uint256,address,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
        'slippage',
        'user.address',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionStatus(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['uint256']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address,uint256,uint256)', [
        'address',
        'slippage',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.oracle', 'getOracle()', [], [
        'uint256[]',
        'uint256[]',
        'uint256[]'
    ]),
    new Method_1.default('xBifi.amountsOfOut', 'getAmountsOut(uint,uint256[2])', [
        'amountIn',
        'tokenIDs'
    ], ['uint'])
], [
    new EntryPoint_1.default('bifi', '0x736a348bb7bdad117755c88bc4e1ab4ef07c5c50'),
    new EntryPoint_1.default('pool.uniswap.bfceth', '0xeaCE4E60F68E20797Fc696c870066f1E19C2b37d'),
    new EntryPoint_1.default('pool.uniswap.bifieth', '0x18740cea640cba9Ce836DC80cE61c7b9ca4f11cb'),
    new EntryPoint_1.default('pool.sushiswap.bfceth', '0x9397c1901563c191B58794bd95Be96eCd9F0d01D'),
    new EntryPoint_1.default('pool.sushiswap.bifieth', '0x3E880c804Eca680D64C0Ae5cD1D88cF74F0D5eb7'),
    new EntryPoint_1.default('stake.bfc', '0x488933457E89656D7eF7E69C10F2f80C7acA19b5'),
    new EntryPoint_1.default('bifi.resolver', '0xab6af9a773f9CBA6B15Db625ac51daa2F1a894E7'),
    new EntryPoint_1.default('bifi.btcdb', '0x1543da6368937d7d377707D8A3663a024fD4AE66'),
    new EntryPoint_1.default('bifi.bitcoin', '0x281553f17440F815C252Ac5431698d448727491E'),
    new EntryPoint_1.default('bifi.btcfund', '0xc6accBE130E1c4DC253D87059f8Ed4fb127871Bd'),
    new EntryPoint_1.default('xBifi', '0x2747f01f2B5A5b164926c631Df079Ccb5F4e5011'),
    new EntryPoint_1.default('xBifi.factory', '0x97ae437EdBACA2DB40CfF2E0436B894Ff72988AF')
], 13000);
//# sourceMappingURL=mainnet.js.map